<template>
  <v-row class="mt-0 mx-4">
    <v-col cols="12" class="py-0 my-0">
      <v-divider></v-divider>
    </v-col>
    <v-col
      cols="5"
      sm="4"
      md="7"
      lg="8"
      class="d-flex justify-star text-body-2 pt-0 mt-0"
      v-if="isRoutePin"
    >
      <v-dialog-pin :dialogPin="dialogAccountPin" />
    </v-col>
    <v-col cols="5" sm="4" md="7" lg="8" class="d-flex flex-nowrap align-center pt-0" v-else>
      <v-btn
        text
        small
        v-for="(item, index) in bannerActionItems"
        :key="index"
        :to="item.to"
        class="text-capitalize text-caption"
      >
        {{ item.name }}
      </v-btn>
    </v-col>
    <v-col cols="7" sm="8" md="5" lg="4" class="d-flex justify-end flex-wrap flex-sm-nowrap pt-0">
      <v-btn color="blue darken-1" text medium @click="save"> Guardar </v-btn>
      <v-btn color="blue darken-1" text medium :to="nextPage" class="ml-10" v-if="this.$route.name !== 'generalObservation'">
        <v-icon>mdi-arrow-right-thick</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import VDialogPin from '@/components/base/VDialogPin.vue';

export default {
  name: 'VBannerActionForm',
  components: {
    VDialogPin,
  },
  props: ['bannerActionItems', 'save', 'nextPage', 'dialogAccountPin'],
  computed: {
    isRoutePin() {
      switch (this.$route.name) {
        case 'profile-a':
          return true;
        case 'patient-a':
          return true;
        default:
          return false;
      }
    },
  },
};
</script>
